import { useCallback } from 'react';
import { DutyLineFlag } from 'components/enums';
import {
  DutyMutationTypeEnum,
  DutyMutationType
} from './useMutateDutyLinesInBulk.types';
import { BulkDeps } from '../HoursTable.types';
import { GridRowSelectionModel } from '@mui/x-data-grid/models/gridRowSelectionModel';

export function useBulkActions({
  apiRef,
  selectedRows,
  setSelectedRows,
  employeeId,
  isEmployeePortal,
  mutateDutyLinesInBulk
}: BulkDeps) {
  const emptySelection: GridRowSelectionModel = {
    type: 'include',
    ids: new Set()
  };

  const clearSelection = useCallback(() => {
    apiRef?.current?.setRowSelectionModel(emptySelection);
    setSelectedRows([]);
  }, [apiRef, setSelectedRows]);

  const handleBulkActions = useCallback(
    async (type: DutyMutationType) => {
      if (!selectedRows.length) return;

      const dutyLineIds = selectedRows.reduce<number[]>((acc, row: any) => {
        if (row.requestId != null) acc.push(row.requestId);
        return acc;
      }, []);

      if (!dutyLineIds.length) {
        clearSelection();
        return;
      }

      if (type === DutyMutationTypeEnum.ADD) {
        await mutateDutyLinesInBulk({
          employeeId,
          isEmployeePortal,
          dutyLineIds,
          flags: [DutyLineFlag.APPROVED],
          type: DutyMutationTypeEnum.ADD
        });
      } else {
        await mutateDutyLinesInBulk({
          employeeId,
          isEmployeePortal,
          dutyLineIds,
          type
        });
      }
      clearSelection();
    },
    [
      selectedRows,
      mutateDutyLinesInBulk,
      employeeId,
      isEmployeePortal,
      clearSelection
    ]
  );

  return { handleBulkActions, clearSelection };
}
